(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_a199d30"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-pointer-hero')) {
    const promptSequence = [
      'touch-me', 'harder', 'harder', 'harder', 'faster',
      'harder', 'faster', 'yes', 'faster', 'harder',
      'harder', 'faster', 'faster', 'love-me'
    ];

    customElements.define('product-pointer-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.querySelector('[data-trail-stage]')) {
          this.initialize();
        } else {
          this.initFrame = requestAnimationFrame(() => this.initialize());
        }
      }

      initialize() {
        if (!this.isConnected) return;
        this.teardown();

        this.stage = this.querySelector('[data-trail-stage]');
        this.layer = this.querySelector('[data-trail-layer]');
        this.background = this.querySelector('.pt__background');
        this.textFrame = this.querySelector('[data-trail-text-frame]');
        this.buttons = this.querySelector('.pt__buttons');
        if (!this.stage || !this.layer) return;

        this.phase = this.phase || 'idle';
        this.navigationSent = false;
        this.controller = new AbortController();
        this.particles = new Map();
        this.ready = [];
        this.prepared = false;
        this.pointerInside = false;
        this.lastPoint = null;
        this.lastSpawn = null;
        this.lastTime = -Infinity;
        this.pendingTap = null;
        this.assetIndex = 0;
        this.pressCount = this.pressCount || 0;
        this.sequenceIndex = this.sequenceIndex || 0;
        this.growthStep = this.growthStep || 0;

        this.showPromptWord();
        this.classList.toggle('is-touched', this.pressCount > 0);
        this.style.setProperty(
          '--pt-text-scale',
          String(Math.pow(1.1, this.growthStep))
        );

        this.run = (this.run || 0) + 1;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');

        const options = {
          passive: true,
          signal: this.controller.signal
        };

        this.viewportHeader = document.querySelector(
          '[data-theme-header], [role="banner"], body > header'
        );

        this.viewportHeaderAnchor =
          this.viewportHeader?.closest('.shopify-section-group-header-group')
          || this.viewportHeader;

        this.viewportHeaders = [...document.querySelectorAll(
          '[data-theme-header], header, .shopify-section-group-header-group'
        )].filter((header) =>
          !this.contains(header) && !header.contains(this)
        );

        if (
          this.viewportHeader &&
          !this.viewportHeaders.includes(this.viewportHeader)
        ) {
          this.viewportHeaders.push(this.viewportHeader);
        }

        const fitViewport = () => {
          cancelAnimationFrame(this.viewportFrame);
          this.viewportFrame = requestAnimationFrame(
            () => this.fitMobileHeight()
          );
        };

        const fitText = () => {
          cancelAnimationFrame(this.textFitFrame);
          this.textFitFrame = requestAnimationFrame(
            () => this.fitPromptWord()
          );
        };

        window.addEventListener('resize', fitViewport, options);
        window.visualViewport?.addEventListener('resize', fitViewport, options);
        window.visualViewport?.addEventListener('scroll', fitText, options);
        document.fonts?.addEventListener('loadingdone', fitViewport, options);

        const viewportRun = this.run;
        document.fonts?.ready.then(() => {
          if (this.isConnected && this.run === viewportRun) {
            fitViewport();
          }
        });

        if ('ResizeObserver' in window) {
          this.viewportObserver = new ResizeObserver(fitViewport);

          const measured = new Set(this.viewportHeaders);
          measured.add(this.stage);
          if (this.buttons) measured.add(this.buttons);

          measured.forEach((element) =>
            this.viewportObserver.observe(element)
          );
        }

        this.fitMobileHeight();

        this.stage.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' && event.pointerType !== 'pen') return;
          if (this.isControl(document.elementFromPoint(event.clientX, event.clientY))) return;

          this.pointerInside = true;
          this.lastPoint = this.point(event);
          this.prepare();
          this.spawn(this.lastPoint, true);
        }, options);

        this.stage.addEventListener('pointermove', (event) => {
          if (event.pointerType === 'touch' || event.buttons) return;

          if (this.isControl(event.target)) {
            this.pointerInside = false;
            this.lastPoint = null;
            return;
          }

          this.pointerInside = true;
          this.lastPoint = this.point(event);
          this.prepare();
          this.spawn(this.lastPoint);
        }, options);

        this.stage.addEventListener('pointerleave', () => {
          this.pointerInside = false;
          this.lastPoint = null;
          this.lastSpawn = null;
        }, options);

        this.stage.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'touch' || this.isControl(event.target)) return;

          this.lastPoint = this.point(event);
          this.pendingTap = {
            point: this.lastPoint,
            time: performance.now()
          };

          this.prepare();

          if (this.ready.length) {
            this.spawn(this.lastPoint, true);
            this.pendingTap = null;
          }
        }, options);

        this.stage.addEventListener('click', (event) => {
          if (event.button !== 0 || this.isControl(event.target)) return;
          this.advancePrompt();
        }, options);

        this.stage.addEventListener('pointercancel', () => {
          this.pendingTap = null;
        }, options);

        window.addEventListener('scroll', () => {
          this.pendingTap = null;
          fitText();
          this.syncTerminalVisibility();
        }, options);

        window.addEventListener('pageshow', (event) => {
          if (event.persisted) this.resetSequence();
        }, options);

        document.addEventListener('visibilitychange', () => {
          if (document.hidden) {
            this.pointerInside = false;
            this.pendingTap = null;
            this.clearParticles();

            if (this.phase === 'idle') {
              this.hidePrompt();
            }
          }

          this.syncTerminalVisibility();
        }, options);

        this.motion.addEventListener(
          'change',
          () => this.clearParticles(),
          options
        );

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
              this.prepare();
            } else {
              this.pointerInside = false;
              this.pendingTap = null;
              this.clearParticles();

              if (this.phase === 'idle') {
                this.hidePrompt();
              }
            }

            this.syncTerminalVisibility();
          }, {
            rootMargin: '160px'
          });

          this.observer.observe(this.stage);
        } else {
          this.prepare();
        }
      }

      fitMobileHeight() {
        if (!this.isConnected) return;

        const rootTop = Math.max(
          0,
          this.getBoundingClientRect().top + window.scrollY
        );

        const anchor = this.viewportHeaderAnchor;
        const anchorStyle = anchor ? getComputedStyle(anchor) : null;
        const pinned = anchorStyle &&
          ['fixed', 'sticky'].includes(anchorStyle.position);

        const anchorTop = anchor
          ? Math.max(
              0,
              pinned
                ? parseFloat(anchorStyle.top) || 0
                : anchor.getBoundingClientRect().top + window.scrollY
            )
          : 0;

        const headerBottom =
          anchorTop + (this.viewportHeader?.getBoundingClientRect().height || 0);
        const inset = Math.max(0, headerBottom - rootTop);

        this.style.setProperty('--pt-mobile-inset', `${inset}px`);
        this.style.setProperty('--pt-mobile-offset', `${rootTop + inset}px`);

        this.fitPromptWord();
        this.syncTerminalVisibility();
      }

      showPromptWord() {
        const key = promptSequence[this.sequenceIndex];

        this.background?.querySelectorAll('[data-trail-word]').forEach((word) => {
          word.classList.toggle('is-active', word.dataset.trailWord === key);
        });

        this.fitPromptWord();
      }

      fitPromptWord() {
        const word = this.background?.querySelector(
          '[data-trail-word].is-active'
        );

        if (!word || !this.stage || !this.textFrame) return;

        word.removeAttribute('transform');

        const bounds = word.getBBox();
        const stage = this.stage.getBoundingClientRect();

        if (
          !bounds.width ||
          !bounds.height ||
          !stage.width ||
          !stage.height
        ) return;

        const viewport = window.visualViewport;
        const viewportTop = viewport?.offsetTop || 0;
        const viewportBottom =
          viewportTop + (viewport?.height || innerHeight);

        let top = Math.max(stage.top, viewportTop);
        let bottom = Math.min(stage.bottom, viewportBottom);

        const headerBounds = (this.viewportHeaders || [])
          .map((header) => {
            const style = getComputedStyle(header);

            return style.display !== 'none' &&
              style.visibility !== 'hidden'
              ? header.getBoundingClientRect()
              : null;
          })
          .filter((rect) =>
            rect && rect.width > 0 && rect.height > 0
          )
          .sort((a, b) => a.top - b.top);

        headerBounds.forEach((rect) => {
          if (
            rect.top <= top + 1 &&
            rect.bottom > top &&
            rect.left < stage.right &&
            rect.right > stage.left
          ) {
            top = Math.max(top, rect.bottom);
          }
        });

        this.buttons?.querySelectorAll('.pt__button').forEach((button) => {
          const rect = button.getBoundingClientRect();
          const style = getComputedStyle(button);

          if (
            rect.width > 0 &&
            rect.height > 0 &&
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            rect.bottom > top &&
            rect.top < bottom
          ) {
            bottom = Math.min(bottom, rect.top);
          }
        });

        const ratioY = stage.height / this.stage.clientHeight || 1;
        const padding = this.stage.clientWidth < 750 ? 16 : 20;
        const frameTop =
          Math.max(0, (top - stage.top) / ratioY) + padding;
        const frameHeight =
          Math.max(0, (bottom - top) / ratioY - padding * 2);

        this.textFrame.style.top = frameTop + 'px';
        this.textFrame.style.height = frameHeight + 'px';

        const isFinalWord = word.dataset.trailWord === 'love-me';
        this.classList.toggle('is-final-word', isFinalWord);

        const mobile = matchMedia(
          '(max-width: 749px), (max-width: 1023px) and (pointer: coarse)'
        ).matches;

        const baseWidth = Math.min(
          this.stage.clientWidth * (mobile ? .86 : .82),
          1120
        );

        const desiredScale =
          baseWidth / 1967 * Math.pow(1.1, this.growthStep);

        const scale = Math.max(0, Math.min(
          this.textFrame.clientWidth / bounds.width,
          frameHeight / bounds.height,
          isFinalWord ? Infinity : desiredScale
        ));

        this.background.setAttribute(
          'viewBox',
          [bounds.x, bounds.y, bounds.width, bounds.height].join(' ')
        );

        this.background.style.width = bounds.width * scale + 'px';
        this.background.style.height = bounds.height * scale + 'px';
      }

      advancePrompt() {
        if (this.phase !== 'idle') return;

        this.pressCount += 1;
        this.sequenceIndex =
          (this.sequenceIndex + 1) % promptSequence.length;
        this.growthStep = Math.max(0, this.sequenceIndex - 1);

        this.classList.add('is-touched');
        this.hidePrompt();
        this.showPromptWord();

        this.style.setProperty(
          '--pt-text-scale',
          String(Math.pow(1.1, this.growthStep))
        );

        if (!this.background) return;

        const opacity =
          parseFloat(
            getComputedStyle(this).getPropertyValue('--pt-text-opacity')
          ) || 1;

        const isFinalWord =
          promptSequence[this.sequenceIndex] === 'love-me';
        const hold = isFinalWord ? 2000 : 500;
        const duration = 60 + hold + (isFinalWord ? 0 : 240);
        const run = this.run;

        if (isFinalWord) {
          this.phase = 'final';
          this.clearParticles();
        }

        const animation = this.background.animate([
          { opacity: 0, offset: 0 },
          { opacity, offset: 60 / duration },
          { opacity, offset: (60 + hold) / duration },
          { opacity: isFinalWord ? opacity : 0, offset: 1 }
        ], {
          delay: 80,
          duration,
          easing: 'linear',
          fill: 'both'
        });

        this.promptAnimation = animation;

        if (isFinalWord) {
          this.syncTerminalVisibility();
        }

        animation.finished.then(() => {
          if (
            !this.isConnected ||
            this.run !== run ||
            this.promptAnimation !== animation
          ) return;

          this.promptAnimation = null;

          if (isFinalWord) {
            this.startExplosion();
          }

          animation.cancel();
        }, () => {});
      }

      isStageVisible() {
        if (
          !this.isConnected ||
          document.hidden ||
          !this.stage
        ) return false;

        const rect = this.stage.getBoundingClientRect();

        return rect.bottom > 0 &&
          rect.top < innerHeight &&
          rect.right > 0 &&
          rect.left < innerWidth;
      }

      syncTerminalVisibility() {
        if (!['final', 'exploding', 'ready'].includes(this.phase)) return;

        const visible = this.isStageVisible();

        if (this.explosionLayer) {
          this.explosionLayer.hidden = !visible;
        }

        const animations = [...(this.explosionAnimations || [])];

        if (this.phase === 'final' && this.promptAnimation) {
          animations.push(this.promptAnimation);
        }

        animations.forEach((animation) => {
          if (!visible && animation.playState === 'running') {
            animation.pause();
          } else if (visible && animation.playState === 'paused') {
            animation.play();
          }
        });

        if (this.phase === 'exploding') {
          this.renderExplosion();
        }

        if (visible && this.phase === 'ready') {
          this.redirectToProduct();
        }
      }

      startExplosion() {
        if (!this.isConnected || this.phase !== 'final') return;

        this.phase = 'exploding';
        this.clearParticles();

        const run = this.run;

        const layer = document.createElement('div');
        layer.className = 'pt__explosion';
        layer.setAttribute('data-product-trail-overlay', this.id);
        layer.setAttribute('aria-hidden', 'true');

        const canvas = document.createElement('canvas');
        canvas.className = 'pt__pill-canvas';

        layer.append(canvas);
        document.body.append(layer);

        this.explosionLayer = layer;
        this.explosionCanvas = canvas;
        this.explosionContext = canvas.getContext('2d');

        this.explosionFlightDuration = this.motion.matches ? 0 : 900;
        this.explosionHoldDuration = 2000;

        const holdEnd =
          this.explosionFlightDuration + this.explosionHoldDuration;
        const duration = holdEnd + 180;

        this.explosionSprites = this.explosionContext
          ? Array.from(
              { length: 6 },
              (_, index) => this.makePillSprite(index)
            )
          : [];

        const edgeAnchors = [
          [0, 0], [.5, 0], [1, 0], [1, .5],
          [1, 1], [.5, 1], [0, 1], [0, .5],
          [.25, 0], [.75, 0], [1, .25], [1, .75],
          [.75, 1], [.25, 1], [0, .75], [0, .25]
        ];

        this.explosionDrops = Array.from(
          { length: 1000 },
          (_, index) => {
            const angle =
              index * 2.3999632297 + (Math.random() - .5) * .3;
            const radius = Math.sqrt(Math.random());
            const edge = .56 / Math.max(
              Math.abs(Math.cos(angle)),
              Math.abs(Math.sin(angle))
            );
            const near = index % 13 === 0;
            const anchor = near ? edgeAnchors[index / 13] : null;

            return {
              x: anchor
                ? anchor[0]
                : .5 + Math.cos(angle) * edge * radius,
              y: anchor
                ? anchor[1]
                : .5 + Math.sin(angle) * edge * radius,
              angle,
              near,
              size: near
                ? 18 + Math.pow(Math.random(), 2) * 32
                : 2.2 + Math.pow(Math.random(), 2) * 5.2,
              aspect: .9 + Math.random() * .15,
              delay: Math.random() * 70,
              flight: 380 + Math.random() * 360,
              rotation: Math.random() * Math.PI * 2,
              spin: (Math.random() < .5 ? -1 : 1)
                * Math.PI * (.5 + Math.random() * 2),
              tilt: Math.random() * Math.PI * 2,
              sprite: index % 6
            };
          }
        ).sort((a, b) => a.size - b.size);

        const clock = layer.animate([
          { opacity: 1, offset: 0 },
          { opacity: 1, offset: holdEnd / duration },
          { opacity: 0, offset: 1 }
        ], {
          duration,
          easing: 'linear',
          fill: 'both'
        });

        this.explosionClock = clock;
        this.explosionAnimations = new Set([clock]);
        this.syncTerminalVisibility();

        clock.finished.then(() => {
          if (
            !this.isConnected ||
            this.run !== run ||
            this.explosionClock !== clock ||
            this.phase !== 'exploding'
          ) return;

          cancelAnimationFrame(this.explosionFrame);
          this.explosionFrame = null;
          this.phase = 'ready';
          this.syncTerminalVisibility();
        }, () => {});
      }

      makePillSprite(index) {
        const sprite = document.createElement('canvas');
        sprite.width = sprite.height = 192;

        const context = sprite.getContext('2d');
        context.scale(1.5, 1.5);

        const colors = [
          '#ffd43b',
          '#ff66b2',
          '#66c7ff',
          '#aa83ed',
          '#70d9a3',
          '#ff9a5b'
        ];

        const channels = colors[index]
          .match(/[a-f0-9]{2}/gi)
          .map((hex) => parseInt(hex, 16));

        const tint = (white) =>
          'rgb(' + channels.map((value) =>
            Math.round(value + (255 - value) * white)
          ).join(',') + ')';

        const shade = (amount, alpha = 1) =>
          'rgba(' + channels.map((value) =>
            Math.round(value * amount)
          ).join(',') + ',' + alpha + ')';

        const round =
          'M107 60A43 43 0 1 1 21 60A43 43 0 1 1 107 60Z';

        const shapes = [
          round,
          'M64 103C54 93 22 72 20 49C18 25 43 15 64 34C85 15 110 25 108 49C106 72 74 93 64 103Z',
          'M64 15L105 38V84L64 107L23 84V38Z',
          'M33 23H95Q107 23 107 35V87Q107 99 95 99H33Q21 99 21 87V35Q21 23 33 23Z',
          round,
          'M46 18H82L107 43V79L82 104H46L21 79V43Z'
        ];

        const shape = new Path2D(shapes[index]);

        context.save();
        context.translate(2, 7);
        context.filter = 'blur(3px)';
        context.fillStyle = 'rgba(20, 20, 30, .24)';
        context.fill(shape);
        context.restore();

        context.save();
        context.translate(0, 6);
        context.fillStyle = shade(.66);
        context.fill(shape);
        context.restore();

        const face = context.createLinearGradient(30, 15, 93, 105);
        face.addColorStop(0, tint(.4));
        face.addColorStop(.55, colors[index]);
        face.addColorStop(1, shade(.86));

        context.fillStyle = face;
        context.fill(shape);

        const bevel = context.createLinearGradient(25, 20, 95, 105);
        bevel.addColorStop(0, tint(.72));
        bevel.addColorStop(.5, tint(.12));
        bevel.addColorStop(1, shade(.64));

        context.strokeStyle = bevel;
        context.lineWidth = 4;
        context.lineJoin = 'round';
        context.stroke(shape);

        context.save();
        context.clip(shape);

        let seed = (index + 1) * 113;

        const random = () => {
          seed = (seed * 1664525 + 1013904223) >>> 0;
          return seed / 4294967296;
        };

        for (let i = 0; i < 170; i += 1) {
          context.beginPath();
          context.arc(
            15 + random() * 98,
            12 + random() * 98,
            .18 + random() * .45,
            0,
            Math.PI * 2
          );

          context.fillStyle = i % 3
            ? 'rgba(255,255,255,.28)'
            : 'rgba(20,20,20,.08)';

          context.fill();
        }

        context.restore();

        const mark = new Path2D();

        if (index === 0) {
          mark.moveTo(52, 51);
          mark.arc(49, 51, 3, 0, Math.PI * 2);
          mark.moveTo(82, 51);
          mark.arc(79, 51, 3, 0, Math.PI * 2);
          mark.moveTo(44, 66);
          mark.bezierCurveTo(50, 86, 78, 86, 84, 66);
        } else if (index === 1) {
          mark.addPath(new Path2D(
            'M64 82C57 75 43 65 43 55C43 44 56 41 64 51C72 41 85 44 85 55C85 65 71 75 64 82Z'
          ));
        } else if (index === 2) {
          for (let i = 0; i < 10; i += 1) {
            const angle = -Math.PI / 2 + i * Math.PI / 5;
            const radius = i % 2 ? 10 : 24;
            const x = 64 + Math.cos(angle) * radius;
            const y = 61 + Math.sin(angle) * radius;

            if (i === 0) mark.moveTo(x, y);
            else mark.lineTo(x, y);
          }

          mark.closePath();
        } else if (index === 3) {
          mark.addPath(new Path2D(
            'M70 36L45 65H61L56 87L84 56H67Z'
          ));
        } else if (index === 4) {
          mark.arc(64, 60, 24, 0, Math.PI * 2);
          mark.moveTo(64, 36);
          mark.lineTo(64, 84);
          mark.moveTo(64, 60);
          mark.lineTo(47, 77);
          mark.moveTo(64, 60);
          mark.lineTo(81, 77);
        } else {
          for (let i = 0; i < 6; i += 1) {
            const angle = i * Math.PI / 3;
            const x = 64 + Math.cos(angle) * 16;
            const y = 61 + Math.sin(angle) * 16;

            mark.moveTo(x + 8, y);
            mark.arc(x, y, 8, 0, Math.PI * 2);
          }

          mark.moveTo(71, 61);
          mark.arc(64, 61, 7, 0, Math.PI * 2);
        }

        context.save();
        context.translate(.8, 1.2);
        context.strokeStyle = tint(.78);
        context.lineWidth = 3.6;
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.stroke(mark);
        context.restore();

        context.strokeStyle = shade(.43, .92);
        context.lineWidth = 2.6;
        context.lineCap = 'round';
        context.lineJoin = 'round';
        context.stroke(mark);

        return sprite;
      }

      renderExplosion() {
        cancelAnimationFrame(this.explosionFrame);
        this.explosionFrame = null;

        if (
          this.phase !== 'exploding' ||
          !this.explosionClock
        ) return;

        this.drawExplosion(
          Number(this.explosionClock.currentTime) || 0
        );

        if (
          this.explosionClock.playState === 'running' &&
          this.isStageVisible() &&
          Number(this.explosionClock.currentTime) <
            this.explosionFlightDuration
        ) {
          this.explosionFrame = requestAnimationFrame(
            () => this.renderExplosion()
          );
        }
      }

      drawExplosion(time) {
        const canvas = this.explosionCanvas;
        const context = this.explosionContext;

        if (
          !canvas ||
          !context ||
          !this.explosionDrops
        ) return;

        const { width, height } =
          this.explosionLayer.getBoundingClientRect();

        if (width <= 0 || height <= 0) return;

        const ratio = Math.min(
          window.devicePixelRatio || 1,
          1.75,
          Math.sqrt(2200000 / (width * height))
        );

        const pixelWidth = Math.max(
          1,
          Math.round(width * ratio)
        );
        const pixelHeight = Math.max(
          1,
          Math.round(height * ratio)
        );

        if (
          canvas.width !== pixelWidth ||
          canvas.height !== pixelHeight
        ) {
          canvas.width = pixelWidth;
          canvas.height = pixelHeight;
        }

        context.setTransform(1, 0, 0, 1, 0, 0);
        context.clearRect(0, 0, canvas.width, canvas.height);

        const originX = width * .5;
        const originY = height * .5;

        const unit = Math.max(.72, Math.min(
          1.6,
          Math.min(width, height) / 520
        ));

        const settled = time >= this.explosionFlightDuration;

        for (const drop of this.explosionDrops) {
          const age = time - drop.delay;

          if (!settled && age < 0) continue;

          const progress = settled
            ? 1
            : Math.min(1, age / drop.flight);

          const travel = drop.near
            ? progress * progress / (1.8 - .8 * progress)
            : 1 - Math.pow(1 - progress, 2.4);

          const depth = drop.near
            ? (1 / (1 - .86 * progress) - 1) / (1 / .14 - 1)
            : .12 + .88 * progress;

          const radius =
            drop.size * unit * (.04 + .96 * depth);

          const tilt = 1 - (1 - progress) * .45 * Math.abs(
            Math.sin(drop.tilt + progress * Math.PI * 4)
          );

          const rx = radius;
          const ry = radius * drop.aspect * tilt;

          const x =
            originX + (drop.x * width - originX) * travel;
          const y =
            originY + (drop.y * height - originY) * travel;

          const rotation =
            drop.rotation + drop.spin * (1 - progress);
          const cos = Math.cos(rotation) * ratio;
          const sin = Math.sin(rotation) * ratio;

          context.setTransform(
            cos, sin, -sin, cos, x * ratio, y * ratio
          );

          context.globalAlpha = Math.min(1, progress * 9);

          context.drawImage(
            this.explosionSprites[drop.sprite],
            -rx,
            -ry,
            rx * 2,
            ry * 2
          );
        }

        context.globalAlpha = 1;
        context.setTransform(1, 0, 0, 1, 0, 0);
      }

      redirectToProduct() {
        if (
          this.phase !== 'ready' ||
          this.navigationSent ||
          !this.isStageVisible()
        ) return;

        if (
          this.dataset.editor === 'true' ||
          !this.dataset.redirectUrl
        ) {
          this.resetSequence();
          return;
        }

        this.navigationSent = true;
        this.phase = 'done';

        window.location.assign(this.dataset.redirectUrl);
      }

      clearExplosion() {
        cancelAnimationFrame(this.explosionFrame);
        this.explosionFrame = null;

        this.explosionAnimations?.forEach((animation) =>
          animation.cancel()
        );

        this.explosionAnimations?.clear();
        this.explosionLayer?.remove();

        this.explosionLayer = null;
        this.explosionCanvas = null;
        this.explosionContext = null;
        this.explosionClock = null;
        this.explosionDrops = null;
        this.explosionSprites = null;
      }

      resetSequence() {
        this.hidePrompt();
        this.clearExplosion();
        this.clearParticles();

        this.phase = 'idle';
        this.navigationSent = false;
        this.pressCount = 0;
        this.sequenceIndex = 0;
        this.growthStep = 0;

        this.classList.remove('is-touched');
        this.style.setProperty('--pt-text-scale', '1');

        this.showPromptWord();
      }

      hidePrompt() {
        this.promptAnimation?.cancel();
        this.promptAnimation = null;
      }

      isControl(target) {
        return target instanceof Element && Boolean(
          target.closest(
            'a, button, input, select, textarea, [data-trail-ignore]'
          )
        );
      }

      point(event) {
        const rect = this.stage.getBoundingClientRect();

        return {
          x: event.clientX - rect.left,
          y: event.clientY - rect.top
        };
      }

      prepare() {
        if (this.prepared) return;

        this.prepared = true;

        const run = this.run;
        const sources = [
          ...this.querySelectorAll('[data-trail-source]')
        ];

        sources.forEach((source) => {
          const image = new Image();
          image.decoding = 'async';
          image.alt = '';

          image.onload = async () => {
            try {
              await image.decode();
            } catch (_) {
              /* A loaded image remains usable. */
            }

            if (
              !this.isConnected ||
              this.run !== run ||
              !image.naturalWidth
            ) return;

            this.ready.push(image);

            if (
              this.pendingTap &&
              performance.now() - this.pendingTap.time < 1000
            ) {
              this.spawn(this.pendingTap.point, true);
              this.pendingTap = null;
            } else if (
              this.pointerInside &&
              this.lastPoint &&
              this.lastTime === -Infinity
            ) {
              this.spawn(this.lastPoint, true);
            }
          };

          image.onerror = () => {};
          image.src = source.dataset.src;
        });
      }

      spawn(point, force = false) {
        if (
          this.phase !== 'idle' ||
          !point ||
          !this.ready.length ||
          document.hidden
        ) return;

        const now = performance.now();
        const spacing = Number(this.dataset.distance) || 60;

        if (!force && now - this.lastTime < 85) return;

        if (
          !force &&
          this.lastSpawn &&
          Math.hypot(
            point.x - this.lastSpawn.x,
            point.y - this.lastSpawn.y
          ) < spacing
        ) return;

        const rect = this.stage.getBoundingClientRect();

        if (!rect.width || !rect.height) return;

        const mobile = rect.width < 750;

        const baseSize = Number(
          mobile ? this.dataset.mobileSize : this.dataset.size
        ) || 240;

        const size = Math.min(
          baseSize * (.86 + Math.random() * .28),
          rect.width * .66,
          rect.height * .8
        );

        const direction =
          this.lastSpawn && point.x < this.lastSpawn.x
            ? -1
            : 1;

        const drift = this.motion.matches
          ? 0
          : direction * Math.min(
              Number(this.dataset.drift) || 48,
              rect.width * .12
            );

        const marginX = size / 2 + Math.abs(drift);

        const x = Math.max(
          marginX,
          Math.min(rect.width - marginX, point.x)
        );

        const y = Math.max(
          size / 2,
          Math.min(rect.height - size / 2, point.y)
        );

        const limit = Number(this.dataset.limit) || 7;

        if (this.particles.size >= limit) {
          const [oldNode, oldAnimation] =
            this.particles.entries().next().value;

          oldAnimation.cancel();
          oldNode.remove();
          this.particles.delete(oldNode);
        }

        const particle = document.createElement('span');
        particle.className = 'pt__particle';

        particle.style.cssText =
          `left:${x}px;top:${y}px;width:${size}px;height:${size}px;`;

        const image = this.ready[
          this.assetIndex++ % this.ready.length
        ].cloneNode();

        image.alt = '';
        image.draggable = false;

        particle.append(image);
        this.layer.append(particle);

        const animation = image.animate([
          {
            transform: 'translateX(0px)',
            opacity: 0,
            offset: 0
          },
          {
            transform: `translateX(${drift * .08}px)`,
            opacity: 1,
            offset: .07
          },
          {
            transform: `translateX(${drift * .8}px)`,
            opacity: 1,
            offset: .78
          },
          {
            transform: `translateX(${drift}px)`,
            opacity: 0,
            offset: 1
          }
        ], {
          duration: Number(this.dataset.lifetime) || 1600,
          easing: this.motion.matches
            ? 'linear'
            : 'steps(9, end)',
          fill: 'both'
        });

        this.particles.set(particle, animation);

        const remove = () => {
          particle.remove();
          this.particles?.delete(particle);
        };

        animation.finished.then(remove, remove);

        this.lastSpawn = { ...point };
        this.lastTime = now;
      }

      clearParticles() {
        this.particles?.forEach((animation, particle) => {
          animation.cancel();
          particle.remove();
        });

        this.particles?.clear();
      }

      teardown() {
        this.run = (this.run || 0) + 1;

        this.controller?.abort();
        this.observer?.disconnect();
        this.viewportObserver?.disconnect();

        cancelAnimationFrame(this.viewportFrame);
        cancelAnimationFrame(this.textFitFrame);

        this.hidePrompt();
        this.clearExplosion();
        this.clearParticles();

        if (this.phase && this.phase !== 'idle') {
          this.phase = 'idle';
          this.pressCount = 0;
          this.sequenceIndex = 0;
          this.growthStep = 0;
          this.navigationSent = false;
        }
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.teardown();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
